import React from 'react'
import '../css/footerBottom.css'

// import Container from '@material-ui/core/Container';
// import Grid from '@material-ui/core/Grid';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';



function FooterBottom() {
  return (
    <div>

    <div className='footerBottom'>
      <div className='footer-info'>
      <Link to="/" className='footer-logo' ><img src="../img/Sanskar_Logo_new.webp"/></Link>

      <ul>
      <li><Link to="https://www.facebook.com/SanskarSchoolIndia"><FacebookIcon className='footer-social-icon'/></Link></li>
      <li><Link to="https://www.instagram.com/sanskarjaipur/?fbclid=IwZXh0bgNhZW0CMTEAAR1bfJqUkNP531xL0OoNjI8T38qB29k_7nYywU_Hrtt1tCtiSIw4XfBzIG0_aem_OKyam76bkdFyRDovUvpOIA"><InstagramIcon className='footer-social-icon'/></Link></li>
      <li><Link to="https://www.youtube.com/@sanskarschool8310"><YouTubeIcon className='footer-social-icon'/></Link></li>
      <li><Link to="https://twitter.com/SanskarJaipur"><TwitterIcon className='footer-social-icon'/></Link></li>
      <li><Link to="https://www.linkedin.com/company/sanskar-school-jaipur"><LinkedInIcon className='footer-social-icon'/></Link></li>
      </ul>
      </div>

   
    <div className="footer-menu">
          <ul className='footer-quick-links'>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="admission">Admission</Link></li>
          <li><Link to="/pyp">Academic Program</Link></li>
          <li><Link to="/newsletter">Newsletter</Link></li>
          <li><Link to="/events">Photo Gallery</Link></li>
          <li><Link to="/ibdp">IBDP Update</Link></li>
          <li><Link to="/achievements">Achievement</Link></li>
          <li><Link to="/placements">Placement</Link></li>
          <li><Link to="/careercounselling">Career-Counselling</Link></li>
          <li><Link to="/onlinefess">Pay Fee</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/career">Career at Sanskar</Link></li>
          </ul>
    </div>

    <div className='footer-contact-menu'>


    <ul className='footer-contact'>
    <li><span><PhoneIcon className='footer-icons'/></span> <a href="tel:9928170470"> 9928170470 </a> </li>
    <li><span></span> <a href="tel:9001797053"> 9001797053 </a> </li>
    <li><span></span> 0141-2245602 (Fax)</li>
    <li><span><EmailIcon className='footer-icons'/></span> <a href="mailto:info@sanskarjaipur.com">info@sanskarjaipur.com </a> </li>
    <li><span><LocationOnIcon className='footer-icons'/></span> 117-121, Vishwamitra Marg, Hanuman Nagar Ext., Sirsi Road, Jaipur - 302012</li>
    </ul>
    </div>
    </div>
      
    </div>
  )
}

export default FooterBottom
